/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService, PartnerService } from "../../../services";
import { MerchantDetailsParentComponent } from "../merchant-details-parent.component";
import { PartnerCredentials, Merchant, EditType } from "../../../models";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { AddEditPartnersComponent } from "./add-edit-partners/add-edit-partners.component";

@Component({
  selector: "app-partners",
  templateUrl: "./partners.component.html"
})
export class PartnersComponent extends MerchantDetailsParentComponent implements OnInit {
  partners!: PartnerCredentials[];
  faLock = faLock;
  actionInProgress = false;
  editType = EditType;
  modalRef?: BsModalRef;
  @Input("merchant") merchant!: Merchant;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private partnerService: PartnerService,
    private modalService: BsModalService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.partnerService.getPartners(this.merchant.id).subscribe(
      (partnerCreds) => (this.partners = partnerCreds),
      (error) => this.notificationService.error(error.error)
    );
  }

  showPassword(partner: PartnerCredentials) {
    partner.showPassword = !partner.showPassword;
  }

  openModal(type: EditType, title: string, partnerCredentials?: PartnerCredentials, index?: number) {
    const initialState: ModalOptions = {
      initialState: {
        action: type,
        title: title,
        partner: partnerCredentials,
        partners: this.partners,
        merchantId: this.merchant.id
      }
    };
    this.modalRef = this.modalService.show(AddEditPartnersComponent, initialState);

    this.modalRef.content.event.subscribe((partnerCredentials: PartnerCredentials) => {
      switch (type) {
        case EditType.remove:
          if (typeof index === "number") {
            this.partners.splice(index, 1);
          }
          break;
        case EditType.edit:
        case EditType.resetPassword:
          if (typeof index === "number" && index >= 0) {
            this.partners[index] = partnerCredentials;
          }
          break;
        case EditType.add:
          this.partners.push(partnerCredentials);
          break;
      }
    });
  }
}
